var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"error--text"},[_vm._v(" *")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }